<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-header></app-header>
<app-alert-detalhes-beneficio [alertDetalhesBeneficio]=alertDetalhesBeneficio
  [idProdutoSelecionado]="beneficioSelecionadoAlert"
  (alertDetalhesBeneficioFechou)="eventoAlertDetalhesBeneficio($event)">
</app-alert-detalhes-beneficio>
<app-alert-sucesso-padrao (alertSucessoFechou)="sucessoFechou()"
  [descricaoSucesso]="'O download do Manual da Operadora foi feito com sucesso.'"
  [showSucesso]="alertSucesso">
</app-alert-sucesso-padrao>
<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo mb-0">Operadoras</h1>
        <p class="paragrafo mb-4"></p>
        <form [formGroup]="formFiltro" style="min-height: 100%">

          <div class="pesquisa-operadoras">
            <app-select-one [label]="'UF'"
              class="filtro-estado"
              formControlName="estado"
              id="filtroEstadoOperadora"
              [selectedValue]="formFiltro.value.estado"
              (valueChanges)="buscaDadosPorEstado($event)"
              [collection]="listaEstados"
              [panelWidth]="'99px'">
            </app-select-one>
            <app-select-one [label]="'Sub-região'"
              class="filtro-subregiao"
              id="filtroSubregiaoOperadora"
              formControlName="subRegiao"
              [buscaComPesquisa]="true"
              [selectedValue]="formFiltro.value.subRegiao"
              (valueChanges)="buscaDadosPorSubRegiao($event)"
              [collection]="listaSubRegioes"
              [panelWidth]="'423px'">
            </app-select-one>
            <app-select-one [label]="'Operadora'"
              class="filtro-operadora"
              id="filtroNomeOperadora"
              formControlName="operadora"
              [buscaComPesquisa]="true"
              [selectedValue]="formFiltro.value.operadora"
              (valueChanges)="buscaDadosPorOperadora($event)"
              [collection]="listaOperadoras"
              [panelWidth]="'773px'">
            </app-select-one>
            <div class="codigo-beneficio">
              <mat-form-field appearance="outline" class="campo-beneficio">
                <mat-label class="mat-label-text">Benefício</mat-label>
                <div matPrefix class="input-icone">
                  @if (filtroBeneficio && filtroBeneficio?.length > 1) {
                    <i class="fa fa-check-circle fa-lg check" aria-hidden="true"></i>
                  }
                </div>
                <input
                  matInput
                  type="text"
                  id="inputCodigoBeneficio"
                  [value]="filtroBeneficio"
                  (input)="formatarBeneficio($event)"
                  />
              </mat-form-field>
            </div>
          </div>
          <div class="filtro-botao">
            <button
              type="button"
              id="btnFiltrarOcorrencias"
              mat-button
              matPrefix
              id="botaoFiltrarOperadora"
              [disabled]="!campoFiltroPreenchido()"
              class="text-rigth btn botao-outline w-auto botao-filtro-ocorrencia"
              (click)="filtrar()">
              <svg
                width="16"
                height="16"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.65413 8.34668C8.65413 7.6103 9.25109 7.01335 9.98747 7.01335C10.7238 7.01335 11.3208 7.6103 11.3208 8.34668C11.3208 9.08306 10.7238 9.68001 9.98747 9.68001C9.25109 9.68001 8.65413 9.08306 8.65413 8.34668ZM6.21508 9.68001H4.65413C3.91775 9.68001 3.3208 9.08306 3.3208 8.34668C3.3208 7.6103 3.91775 7.01335 4.65413 7.01335H6.21508C6.76419 5.45976 8.24584 4.34668 9.98747 4.34668C11.7291 4.34668 13.2107 5.45976 13.7599 7.01335H28.6541C29.3905 7.01335 29.9875 7.6103 29.9875 8.34668C29.9875 9.08306 29.3905 9.68001 28.6541 9.68001H13.7599C13.2107 11.2336 11.7291 12.3467 9.98747 12.3467C8.24584 12.3467 6.76419 11.2336 6.21508 9.68001ZM25.9875 16.3467C25.9875 15.6103 25.3905 15.0133 24.6541 15.0133C23.9178 15.0133 23.3208 15.6103 23.3208 16.3467C23.3208 17.0831 23.9178 17.68 24.6541 17.68C25.3905 17.68 25.9875 17.0831 25.9875 16.3467ZM20.8817 15.0133H4.65413C3.91776 15.0133 3.3208 15.6103 3.3208 16.3467C3.3208 17.0831 3.91776 17.68 4.65413 17.68H20.8817C21.4309 19.2336 22.9125 20.3467 24.6541 20.3467C26.3958 20.3467 27.8774 19.2336 28.4265 17.68H28.6541C29.3905 17.68 29.9875 17.0831 29.9875 16.3467C29.9875 15.6103 29.3905 15.0133 28.6541 15.0133H28.4265C27.8774 13.4598 26.3958 12.3467 24.6541 12.3467C22.9125 12.3467 21.4309 13.4598 20.8817 15.0133ZM17.9875 28.3467C19.7291 28.3467 21.2107 27.2336 21.7599 25.68H28.6541C29.3905 25.68 29.9875 25.0831 29.9875 24.3467C29.9875 23.6103 29.3905 23.0133 28.6541 23.0133H21.7599C21.2107 21.4598 19.7291 20.3467 17.9875 20.3467C16.2458 20.3467 14.7642 21.4598 14.2151 23.0133H4.65413C3.91776 23.0133 3.3208 23.6103 3.3208 24.3467C3.3208 25.0831 3.91776 25.68 4.65413 25.68L14.2151 25.68C14.7642 27.2336 16.2458 28.3467 17.9875 28.3467ZM17.9875 25.68C18.7238 25.68 19.3208 25.0831 19.3208 24.3467C19.3208 23.6103 18.7238 23.0133 17.9875 23.0133C17.2511 23.0133 16.6541 23.6103 16.6541 24.3467C16.6541 25.0831 17.2511 25.68 17.9875 25.68Z"
                  fill="#008060"
                  />
              </svg>
              FILTRAR
            </button>
            @if (campoFiltroPreenchido()) {
              <button class="filtro-limpar btn-icon" (click)="limparFiltro()" id="botaoLimparFiltroOperadora">
                LIMPAR FILTROS
              </button>
            }
          </div>
        </form>
        @if (beneficioNaoExistente && filtrou) {
          <div class="operadoras-vazia">
            <div>
              <i class="fa fa-exclamation-circle fa-2x" aria-hidden="true"></i>
            </div>
            <div>
              <h1>Não foi encontrado nenhum resultado para o benefício pesquisado.</h1>
            </div>
          </div>
        }
        @if (listaBeneficios?.length) {
          <div class="display-operadoras">
            <table class="table table-hover tabela-operadoras">
              <thead>
                <tr>
                  <th scope="col">SUB-REGIÃO</th>
                  <th scope="col">OPERADORAS</th>
                  <th scope="col">CÓDIGO</th>
                  <th scope="col">BENEFÍCIO</th>
                  <th scope="col">VALOR UNITÁRIO</th>
                  <th scope="col">AÇÕES</th>
                </tr>
              </thead>
              <tbody>
                @for (beneficio of listaBeneficios | paginate: { id: 'operadora', itemsPerPage: pagination.pageSize , currentPage: pagination.currentPagePaginator, totalItems: totalItems}; track beneficio; let i = $index) {
                  <tr
                    >
                    <td>{{beneficio.descSubRegiao | titlecase}}</td>
                    <td>{{beneficio.nomeOperadora | titlecase}}</td>
                    <td>{{beneficio.codProduto}}</td>
                    <td>{{beneficio.descBeneficio | titlecase}}</td>
                    <td>{{beneficio.valorCusto | currency : 'BRL'}}</td>
                    <td class="coluna-acoes">
                      <div class="top-coluna-acoes">
                        <button
                          id="botaoDetalheBeneficio{{i}}"
                          (click)="abrirAlertDetalhesBeneficio(beneficio.idProduto)"
                          (keydown.enter)="abrirAlertDetalhesBeneficio(beneficio.idProduto)"
                          >
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <g clip-path="url(#clip0_4354_60)">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M8.5 0.5C8.22386 0.5 8 0.723858 8 1C8 1.27614 8.22386 1.5 8.5 1.5H9.79297L6.14652 5.14645C5.95126 5.34171 5.95126 5.65829 6.14652 5.85355C6.34178 6.04882 6.65837 6.04882 6.85363 5.85355L10.5 2.20718V3.5C10.5 3.77614 10.7239 4 11 4C11.2761 4 11.5 3.77614 11.5 3.5V1C11.5 0.723858 11.2761 0.5 11 0.5H8.5ZM2.5 3C1.94772 3 1.5 3.44772 1.5 4V9.5C1.5 10.0523 1.94772 10.5 2.5 10.5H8C8.55228 10.5 9 10.0523 9 9.5V6.21875C9 5.94261 9.22386 5.71875 9.5 5.71875C9.77614 5.71875 10 5.94261 10 6.21875V9.5C10 10.6046 9.10457 11.5 8 11.5H2.5C1.39543 11.5 0.5 10.6046 0.5 9.5V4C0.5 2.89543 1.39543 2 2.5 2H5.78125C6.05739 2 6.28125 2.22386 6.28125 2.5C6.28125 2.77614 6.05739 3 5.78125 3H2.5Z"
                                fill="#008060"/>
                            </g>
                            <defs>
                              <clipPath id="clip0_4354_60">
                                <rect width="12" height="12" fill="white"/>
                              </clipPath>
                            </defs>
                          </svg>
                          <span>VER DETALHES</span>
                        </button>
                      </div>
                      <div class="top-coluna-acoes">
                        @if (beneficio.flagManualDown) {
                          <button
                            id="btnBaixarManual{{i}}"
                            (click)="baixarManualOperadora(beneficio.idEmpresaFornecedora)"
                            (keydown.enter)="baixarManualOperadora(beneficio.idEmpresaFornecedora)"
                            >
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M1.5 7.5C1.77614 7.5 2 7.72386 2 8V9C2 9.55228 2.44772 10 3 10H9C9.55229 10 10 9.55228 10 9V8C10 7.72386 10.2239 7.5 10.5 7.5C10.7761 7.5 11 7.72386 11 8V9C11 10.1046 10.1046 11 9 11H3C1.89543 11 1 10.1046 1 9V8C1 7.72386 1.22386 7.5 1.5 7.5Z"
                                fill="#008060"/>
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M6 8C5.72386 8 5.5 7.77614 5.5 7.5L5.5 1.5C5.5 1.22386 5.72386 1 6 1C6.27614 1 6.5 1.22386 6.5 1.5L6.5 7.5C6.5 7.77614 6.27614 8 6 8Z"
                                fill="#008060"/>
                              <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M3.14645 4.64645C2.95118 4.84171 2.95118 5.15829 3.14645 5.35355L5.64645 7.85355C5.84171 8.04882 6.15829 8.04882 6.35355 7.85355L8.85355 5.35355C9.04882 5.15829 9.04882 4.84171 8.85355 4.64645C8.65829 4.45118 8.34171 4.45118 8.14645 4.64645L6 6.79289L3.85355 4.64645C3.65829 4.45118 3.34171 4.45118 3.14645 4.64645Z"
                                fill="#008060"/>
                            </svg>
                            <span>MANUAL DA OPERADORA</span>
                          </button>
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            <div class="paginacao-div">
              <div class="exibicao-paginacao">
                <span><p>Exibir</p></span>
                <app-select
                  ngClass="form-control-selecao select-registros-vale"
                  (valueChanges)="pageSize($event)"
                  [value]="qtdPagina"
                  id="itensPorPaginaOperadora"
                [options]="[
                            {name : '5 REGISTROS' , value : '5'} ,
                            {name : '10 REGISTROS' , value : '10'},
                            {name : '15 REGISTROS' , value : '15'},
                            {name : '20 REGISTROS' , value : '20'}
                            ]"
                  optionValue="value"
                  optionText="name">
                </app-select>
                <i class="fa fa-caret-down c-primary" aria-hidden="true"></i>
                <span><p> por página</p></span>
              </div>
              <div class="paginacao-centro-padding">
                <pagination-controls id="operadora" class="itens-pagina" (pageChange)="getPage($event)"
                  directionLinks="false" autoHide="false"
                  responsive="true" previousLabel="" nextLabel=""
                  screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                  screenReaderCurrentLabel="Página">
                </pagination-controls>
              </div>
              <div class="paginacao-direita-padding">
                <span class="subtitulo-table"><p><b style="font-weight: 600">{{totalItems}}</b> Registros foram encontrados</p></span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
